"use client";

import React from 'react';
import { Check, X, UserCheck, Users } from 'lucide-react';
import { useTranslations } from 'next-intl';

const WhoItsForSection: React.FC = () => {
  const t = useTranslations();

  const forUsers = [
    t('who_for_1'),
    t('who_for_2'),
    t('who_for_3'),
    t('who_for_4'),
    t('who_for_5'),
    t('who_for_6')
  ];

  const notForUsers = [
    t('who_not_for_1'),
    t('who_not_for_2'),
    t('who_not_for_3')
  ];

  return (
    <section className="py-16 md:py-24 bg-background relative overflow-hidden" id="who-for">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-green-500/5 rounded-full blur-[100px] -translate-y-1/2 pointer-events-none"></div>
      <div className="absolute top-1/2 right-0 w-[400px] h-[400px] bg-red-500/5 rounded-full blur-[100px] -translate-y-1/2 pointer-events-none"></div>
      
      <div className="container-std relative z-10">
        {/* Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-black text-foreground mb-6">
            {t('who_for_title')}
          </h2>
          <p className="text-lg text-muted-foreground">
            {t('who_for_desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* For */}
          <div className="glass-card rounded-3xl p-6 md:p-8 border border-green-500/20 bg-green-500/5">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-green-500/20 flex items-center justify-center text-green-400">
                <UserCheck size={24} />
              </div>
              <h3 className="text-2xl font-bold text-foreground">
                {t('who_for_heading')}
              </h3>
            </div>
            
            <ul className="space-y-4">
              {forUsers.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={14} className="text-green-400" />
                  </div>
                  <span className="text-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Not For */}
          <div className="glass-card rounded-3xl p-6 md:p-8 border border-red-500/20 bg-red-500/5">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-red-500/20 flex items-center justify-center text-red-400">
                <Users size={24} />
              </div>
              <h3 className="text-2xl font-bold text-foreground">
                {t('who_not_for_heading')}
              </h3>
            </div>
            
            <ul className="space-y-4">
              {notForUsers.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-red-500/20 flex items-center justify-center shrink-0 mt-0.5">
                    <X size={14} className="text-red-400" />
                  </div>
                  <span className="text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsForSection;
